import React from 'react';
import { Avatar, Typography } from 'antd';
import dayjs from 'dayjs';
import { ChatMessage as ChatMessageType } from '../../../../../types/brands';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import { Bot, User } from 'lucide-react';

const { Text } = Typography;

interface ChatMessageProps {
  message: ChatMessageType;
  username: string;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, username }) => {
  const { fontSize } = useResponsiveSizes();
  const isUser = message.type === 'user';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUser ? 'flex-end' : 'flex-start',
        paddingLeft: isUser ? 40 : 0,
        paddingRight: isUser ? 0 : 40
      }}
    >
      <div
        style={{
          backgroundColor: isUser ? '#8392f0' : '#f0f0f0',
          color: isUser ? 'white' : '#333',
          borderRadius: 16,
          padding: '10px 14px',
          maxWidth: '70%',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 6
          }}
        >
          <Avatar
            size={28}
            icon={isUser ? <User width={15} /> : <Bot width={15} />}
            style={{
              backgroundColor: isUser ? '#eae5d7' : '#4a78dc',
              marginRight: 8,
              color: isUser ? '#4d493e' : 'white'
            }}
          />
          <Text style={{ fontSize: fontSize.base, fontWeight: 500, color: isUser ? 'white' : '#333' }}>
            {isUser ? username.toUpperCase() : 'DRUPI'}
          </Text>
        </div>

        <Text style={{ color: isUser ? 'white' : '#333', fontSize: fontSize.base }}>
          {message.prompt
            .replace(/\\n/g, '\n')
            .split(/(\*\*.*?\*\*)/)
            .map((part, index) =>
              part.startsWith('**') && part.endsWith('**') ? <strong key={index}>{part.slice(2, -2)}</strong> : part
            )}
        </Text>
      </div>

      {/* Hora */}
      <div
        style={{
          marginTop: 6,
          fontSize: fontSize.sm,
          alignSelf: isUser ? 'flex-end' : 'flex-start'
        }}
      >
        <Text style={{ color: '#999' }}>{dayjs(message.createdAt).format('HH:mm')}</Text>
      </div>
    </div>
  );
};
